import axios from "axios";

export const APIURL =
  process.env.NODE_ENV === "production"
    ? "https://clients.dynapark.io/v1"
    : "https://clients.dynapark.io/v1";

export default axios.create({
  baseURL: APIURL,
});
